import merchant from '../action/merchantAction'

export const initialState = ({
  isLoading: false,
  merchants: null,
  pickupRequest: null,
  packageRequest: null,
  orderPackage: null,
  inventory: null,
  status: null,
})


export default function (state = initialState, action) {
  switch (action.type) {

    case merchant.TYPES.REQUEST_MERCHANT:
      return Object.assign({}, state, { merchants: null, isLoading: true, status: null})

    case merchant.TYPES.REQUEST_MERCHANT_SUCCESS:
      return Object.assign({}, state, { merchants: action.payload, isLoading: false, status: null})

    case merchant.TYPES.UPDATE_MERCHANT_LIST:
      return Object.assign({}, state, { merchants: action.payload, isLoading: false, status: null})

    // Pickup request
    case merchant.TYPES.REQUEST_PICKUP_REQUEST:
      return Object.assign({}, state, { pickupRequest: null, isLoading: true, status: null})

    case merchant.TYPES.REQUEST_PICKUP_REQUEST_SUCCESS:
      return Object.assign({}, state, { pickupRequest: action.payload, isLoading: false, status: null})

    case merchant.TYPES.REQUEST_PICKUP_REQUEST_SUCCESS:
      return Object.assign({}, state, { pickupRequest: action.payload, isLoading: false, status: null})

    case merchant.TYPES.UPDATE_PICKUP_REQUEST_LIST:
      return Object.assign({}, state, { pickupRequest: action.payload, isLoading: false, status: null})

    // Package request
    case merchant.TYPES.REQUEST_PACKAGE_REQUEST:
      return Object.assign({}, state, { packageRequest: null, isLoading: true, status: null})

    case merchant.TYPES.REQUEST_PACKAGE_REQUEST_SUCCESS:
      return Object.assign({}, state, { packageRequest: action.payload, isLoading: false, status: null})

    // Package request
    case merchant.TYPES.REQUEST_ORDER_PACKAGE_REQUEST:
      return Object.assign({}, state, { orderPackage: null, isLoading: true, status: null})

    case merchant.TYPES.REQUEST_ORDER_PACKAGE_REQUEST_SUCCESS:
      return Object.assign({}, state, { orderPackage: action.payload, isLoading: false, status: null})

    case merchant.TYPES.UPDATE_ORDER_PACKAGE_LIST:
      return Object.assign({}, state, { orderPackage: action.payload, isLoading: false, status: null})


    // Inventory
    case merchant.TYPES.REQUEST_INVENTORY:
      return Object.assign({}, state, { inventory: null, isLoading: true, status: null})

    case merchant.TYPES.REQUEST_INVENTORY_SUCCESS:
      return Object.assign({}, state, { inventory: action.payload, isLoading: false, status: null})

    case merchant.TYPES.UPDATE_INVENTORY_LIST:
      return Object.assign({}, state, { inventory: action.payload, isLoading: false, status: null})

    default:
      return state
  }
}
